import { supabase } from "./supabaseClient";
import { getWorkspaceConfiguration } from "./salesAffiliateWorkspaceConfig";

const SALES_AFFILIATE_STATUS_FUNCTION = "sales_affiliate_status";
const DEFAULT_AUTHENTICATED_HOME = "/dashboard";

function normalizeFallbackPath(value) {
  const raw = String(value || "").trim();
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) {
    return DEFAULT_AUTHENTICATED_HOME;
  }
  return raw;
}

/**
 * Resolve the correct default home for an authenticated user.
 *
 * - Sales Affiliates use the existing authoritative lifecycle/workspace mapping.
 * - Non-affiliates keep the existing customer default (/dashboard).
 * - Status lookup failures fail safely to the supplied customer fallback.
 * - Explicit workflow destinations (for example ?next=/pricing?plan=pro) should
 *   be honored by callers before invoking this default-home resolver.
 */
export async function resolveAuthenticatedHomePath({
  client = supabase,
  fallbackPath = DEFAULT_AUTHENTICATED_HOME,
} = {}) {
  const safeFallback = normalizeFallbackPath(fallbackPath);

  try {
    const { data, error } = await client.functions.invoke(
      SALES_AFFILIATE_STATUS_FUNCTION,
      { body: {} }
    );

    if (error || !data?.ok || data?.affiliate_exists !== true) {
      return safeFallback;
    }

    const configuration = getWorkspaceConfiguration(data?.lifecycle_state);
    const affiliatePath = String(configuration?.defaultPath || "").trim();

    if (!affiliatePath.startsWith("/") || affiliatePath.startsWith("//")) {
      return safeFallback;
    }

    return affiliatePath;
  } catch {
    return safeFallback;
  }
}
